/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CustomFunctionDefinition } from '../models/custom-function-definition';
import { CustomFunctionDefinitionPartial } from '../models/custom-function-definition-partial';
import { CustomFunctionDefinitionWithRelations } from '../models/custom-function-definition-with-relations';
import { NewCustomFunctionDefinition } from '../models/new-custom-function-definition';
import { UpdateCustomFunctionDefinitionByAiRequestDtoPartial } from '../models/update-custom-function-definition-by-ai-request-dto-partial';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class CustomFunctionDefinitionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation customFunctionDefinitionControllerCount
   */
  static readonly CustomFunctionDefinitionControllerCountPath = '/custom-function-definitions/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerFindTemplateFunctions
   */
  static readonly CustomFunctionDefinitionControllerFindTemplateFunctionsPath = '/custom-function-definitions/templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findTemplateFunctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTemplateFunctions$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<CustomFunctionDefinition>>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerFindTemplateFunctionsPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CustomFunctionDefinition>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findTemplateFunctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findTemplateFunctions(params?: {
    filter?: any;
  }): Observable<Array<CustomFunctionDefinition>> {

    return this.findTemplateFunctions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CustomFunctionDefinition>>) => r.body as Array<CustomFunctionDefinition>)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerUpdateCustomFunctionDefinitionByAi
   */
  static readonly CustomFunctionDefinitionControllerUpdateCustomFunctionDefinitionByAiPath = '/custom-function-definitions/{id}/by-ai';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomFunctionDefinitionByAI()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomFunctionDefinitionByAI$Response(params: {
    id: string;
    body?: UpdateCustomFunctionDefinitionByAiRequestDtoPartial
  }): Observable<StrictHttpResponse<CustomFunctionDefinition>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerUpdateCustomFunctionDefinitionByAiPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomFunctionDefinition>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateCustomFunctionDefinitionByAI$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomFunctionDefinitionByAI(params: {
    id: string;
    body?: UpdateCustomFunctionDefinitionByAiRequestDtoPartial
  }): Observable<CustomFunctionDefinition> {

    return this.updateCustomFunctionDefinitionByAI$Response(params).pipe(
      map((r: StrictHttpResponse<CustomFunctionDefinition>) => r.body as CustomFunctionDefinition)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerFindById
   */
  static readonly CustomFunctionDefinitionControllerFindByIdPath = '/custom-function-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<CustomFunctionDefinitionWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomFunctionDefinitionWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<CustomFunctionDefinitionWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<CustomFunctionDefinitionWithRelations>) => r.body as CustomFunctionDefinitionWithRelations)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerDeleteById
   */
  static readonly CustomFunctionDefinitionControllerDeleteByIdPath = '/custom-function-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerUpdateById
   */
  static readonly CustomFunctionDefinitionControllerUpdateByIdPath = '/custom-function-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: CustomFunctionDefinitionPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: CustomFunctionDefinitionPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerFind
   */
  static readonly CustomFunctionDefinitionControllerFindPath = '/custom-function-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<CustomFunctionDefinitionWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CustomFunctionDefinitionWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<CustomFunctionDefinitionWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CustomFunctionDefinitionWithRelations>>) => r.body as Array<CustomFunctionDefinitionWithRelations>)
    );
  }

  /**
   * Path part for operation customFunctionDefinitionControllerCreate
   */
  static readonly CustomFunctionDefinitionControllerCreatePath = '/custom-function-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewCustomFunctionDefinition
  }): Observable<StrictHttpResponse<CustomFunctionDefinition>> {

    const rb = new RequestBuilder(this.rootUrl, CustomFunctionDefinitionControllerService.CustomFunctionDefinitionControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomFunctionDefinition>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewCustomFunctionDefinition
  }): Observable<CustomFunctionDefinition> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<CustomFunctionDefinition>) => r.body as CustomFunctionDefinition)
    );
  }

}
